export default __webpack_public_path__ + "static/media/lotusoverload.bd8847eb.png";